<!--  -->
<template>
  <div>
    <div class="title">
      <div class="title-text">园区总览</div>
    </div>
    <div class="content">
      <div class="num">
        <div style="margin-right:140px">人员总数</div>
        <div class="pip">
          <div style="font-size:2vh;color:#98fef9;margin-right:8px;font-weight: 600;">1987</div>
          <div style="color: rgba(255, 255, 255, 0.4);">人</div>
        </div>
      </div>
      <div class="statistics">
        <div class="item" style="margin-right:10px">
          <div class="num" style="margin-top:0.8vh">
            <div style="margin-right: 24px;">本厂</div>
            <div class="pip">
              <div style="font-size:1.8vh;color:#98fef9;margin-right:8px;font-weight: 600;">1001</div>
              <div style="color: rgba(255, 255, 255, 0.4);">人</div>
            </div>
          </div>
          <div class="num" style="margin-top:0.8vh">
            <div style="margin-right: 24px;">车辆</div>
            <div class="pip">
              <div style="font-size:1.8vh;color:#98fef9;margin-right:18px;font-weight: 600;">592</div>
              <div style="color: rgba(255, 255, 255, 0.4);">辆</div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="num" style="margin-top:0.8vh">
            <div style="margin-right: 24px;">外来</div>
            <div class="pip">
              <div style="font-size:1.8vh;color:#98fef9;margin-right:18px;font-weight: 600;">986</div>
              <div style="color: rgba(255, 255, 255, 0.4);">人</div>
            </div>
          </div>
          <div class="num" style="margin-top:0.8vh">
            <div style="margin-right: 24px;">占地</div>
            <div class="pip">
              <div style="font-size:1.8vh;color:#98fef9;margin-right:8px;font-weight: 600;">1023</div>
              <div style="color: rgba(255, 255, 255, 0.4);">亩</div>
            </div>
          </div>
        </div>
      </div>
      <div class="text">管理员：肇庆光</div>
      <div class="text" style="margin-top:1.3vh">位置：重庆市江北区兴业大道895号</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.content {
  color: #fff;
  font-family: sy;
  font-size: 1.2vh;
  margin-left: 5%;
  .num {
    display: flex;
    align-items: center;
    .pip {
      text-align: right;
      display: flex;
      align-items: center;
    }
  }
  .statistics {
    height: 8.52vh;
    width: 100%;
    display: flex;
    margin-top: 0.5vh;
    .item {
      height: 100%;
      width: 46%;
      background: url(../../assets/textbox.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .num {
        display: flex;
        align-items: flex-end;
        margin-left: 8px;
        .pip {
          text-align: right;
          display: flex;
          align-items: flex-end;
        }
      }
    }
  }
  .text {
    font-size: 12px;
    color: #fff;
    margin-top: 1vh;
  }
}
</style>